
import styles from "./styles.css";


function My404Component() {
  return (
    <div className="mainContent">
      My404Component
    </div>
  );
}

export default My404Component;
